import React from 'react'
import { Icons } from 'constants/icon'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { Box } from '@mui/material'
import {
  CardGridWrapper,
  StyledContainer,
  FilterContainer,
  FilterButton,
  CardGrid,
  SocialCard,
  CardHeader,
  PlatformBadge,
  CardImage,
  CardContent,
  CardFooter,
  SocialStats,
  ReplyButton,
  DateText,
  ProfileImage,
  PlayButton,
  HashTag,
  ContentText,
  VideoCard,
  VideoContainer,
  VideoOverlay,
  VideoHeader,
  VideoContent,
  VideoHashTag,
  VideoContentText,
  VideoFooter,
  CardWrapper,
  ReplyIcon,
} from './Style'

interface SocialPost {
  platform: 'INSTAGRAM' | 'FACEBOOK' | 'YOUTUBE'
  type: 'image' | 'video'
  image?: string
  videoUrl?: string
  thumbnailUrl?: string
  likes: string
  shares: string
  text: string
  isReplied: boolean
  date: string
  profileImage: string
  hashtag: string
}

const socialPosts: SocialPost[] = [
  {
    platform: 'INSTAGRAM',
    type: 'video',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.iPost,
    hashtag: '#TRUECRIME',
    text: 'Check out this awesome new true crime podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
    videoUrl: Icons.iPost,
    thumbnailUrl: Icons.iPost,
  },
  {
    platform: 'FACEBOOK',
    type: 'image',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.fPost,
    hashtag: '#DOGS',
    text: 'Check out this awesome new dogs podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
  },
  {
    platform: 'YOUTUBE',
    type: 'video',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.yPost,
    hashtag: '#TRUECRIME',
    text: 'Check out this awesome new true crime podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: true,
    videoUrl: Icons.yPost,
    thumbnailUrl: Icons.yPost,
  },
  {
    platform: 'YOUTUBE',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.yPost,
    hashtag: '#TRUECRIME',
    text: 'Check out this awesome new true crime podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
    type: 'video',
    videoUrl: Icons.yPost,
    thumbnailUrl: Icons.yPost,
  },
  {
    platform: 'INSTAGRAM',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.iPost,
    hashtag: '#TRUECRIME',
    text: 'Check out this awesome new true crime podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
    type: 'video',
    videoUrl: Icons.iPost,
    thumbnailUrl: Icons.iPost,
  },
  {
    platform: 'FACEBOOK',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.fPost,
    hashtag: '#DOGS',
    text: 'Check out this awesome new dogs podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
    type: 'image',
  },
  {
    platform: 'FACEBOOK',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.fPost,
    hashtag: '#DOGS',
    text: 'Check out this awesome new dogs podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
    type: 'image',
  },
  {
    platform: 'YOUTUBE',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.yPost,
    hashtag: '#TRUECRIME',
    text: 'Check out this awesome new true crime podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
    type: 'video',
    videoUrl: Icons.yPost,
    thumbnailUrl: Icons.yPost,
  },
  {
    platform: 'INSTAGRAM',
    date: '10/2/2025',
    profileImage: Icons.profile,
    image: Icons.iPost,
    hashtag: '#TRUECRIME',
    text: 'Check out this awesome new true crime podcast about some ridiculous shite ya know. Get er done!!',
    likes: '5.4k',
    shares: '312',
    isReplied: false,
    type: 'video',
    videoUrl: Icons.iPost,
    thumbnailUrl: Icons.iPost,
  },
]

export default function SocialCards(): JSX.Element {
  return (
    <StyledContainer>
      <FilterContainer>
        <FilterButton>LIKES ▼</FilterButton>
        <FilterButton>PLATFORM ▼</FilterButton>
        <FilterButton>CATEGORY ▼</FilterButton>
      </FilterContainer>
      <CardGridWrapper>
        <CardGrid>
          {socialPosts.map((post, index) => (
            <CardWrapper key={index}>
              {post.type === 'video' ? (
                <VideoCard>
                  <VideoContainer>
                    <video
                      src={post.videoUrl}
                      poster={post.thumbnailUrl}
                      controls={false}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                    <PlayButton>
                      <PlayArrowIcon sx={{ fontSize: 40 }} />
                    </PlayButton>
                  </VideoContainer>

                  <VideoOverlay />

                  <VideoHeader>
                    <PlatformBadge>
                      {post.platform}
                      <span className="platform-arrow">›</span>
                    </PlatformBadge>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <DateText>{post.date}</DateText>
                      <ProfileImage src={post.profileImage} alt="Profile" />
                    </Box>
                  </VideoHeader>

                  <VideoContent>
                    <VideoHashTag>{post.hashtag}</VideoHashTag>
                    <VideoContentText>{post.text}</VideoContentText>
                  </VideoContent>

                  <VideoFooter>
                    <SocialStats>
                      <Box className="stat">
                        <img
                          src={Icons.heart}
                          alt="heart"
                          width={27}
                          height={27}
                        />
                        {post.likes}
                      </Box>
                      <Box className="stat">
                        <img
                          src={Icons.retweet}
                          alt="retweet"
                          width={27}
                          height={27}
                        />
                        {post.shares}
                      </Box>
                    </SocialStats>
                    <ReplyButton
                      variant="contained"
                      className={post.isReplied ? 'replied' : 'no-reply'}
                    >
                      {post.isReplied ? (
                        <>
                          <ReplyIcon src={Icons.gCheck} alt="Replied" />
                          REPLIED
                        </>
                      ) : (
                        <>
                          REPLY
                          <ReplyIcon src={Icons.wRightArrow} alt="Reply" />
                        </>
                      )}
                    </ReplyButton>
                  </VideoFooter>
                </VideoCard>
              ) : (
                <SocialCard>
                  <CardHeader>
                    <PlatformBadge>
                      {post.platform}
                      <span className="platform-arrow">›</span>
                    </PlatformBadge>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <DateText>{post.date}</DateText>
                      <ProfileImage src={post.profileImage} alt="Profile" />
                    </Box>
                  </CardHeader>
                  <CardImage
                    sx={{ backgroundImage: `url(${post.image ?? ''})` }}
                  />
                  <CardContent>
                    <HashTag>{post.hashtag}</HashTag>
                    <ContentText>{post.text}</ContentText>
                  </CardContent>
                  <CardFooter>
                    <SocialStats>
                      <Box className="stat">
                        <img
                          src={Icons.heart}
                          alt="heart"
                          width={27}
                          height={27}
                        />
                        {post.likes}
                      </Box>
                      <Box className="stat">
                        <img
                          src={Icons.retweet}
                          alt="retweet"
                          width={27}
                          height={27}
                        />
                        {post.shares}
                      </Box>
                    </SocialStats>
                    <ReplyButton
                      variant="contained"
                      className={post.isReplied ? 'replied' : 'no-reply'}
                    >
                      {post.isReplied ? (
                        <>
                          <ReplyIcon src={Icons.gCheck} alt="Replied" />
                          REPLIED
                        </>
                      ) : (
                        <>
                          REPLY
                          <ReplyIcon src={Icons.wRightArrow} alt="Reply" />
                        </>
                      )}
                    </ReplyButton>
                  </CardFooter>
                </SocialCard>
              )}
            </CardWrapper>
          ))}
        </CardGrid>
      </CardGridWrapper>
    </StyledContainer>
  )
}
